<template>
    <div class="unavailable-buttons">
        <div v-if="isComplete" class="button">
            <a href="#" class="btn btn-yellow" @click.prevent="publishSpace">Publish Listing</a>
        </div>
        <div :class="{ 'full-width': !isComplete }" class="button">
            <a :href="editRoute" class="btn btn-green">Edit listing</a>
        </div>
        <booking-alerts v-if="states.errors.length" :messages="states.errors"/>
    </div>
</template>

<script>
    import ListingRepository from '../../../repositories/ListingRepository';
    import BookingAlerts from '../booking-form/Alerts';
    import { normaliseErrors } from '../../../modules/error-handlers';
    import moment from '../../../modules/moment';

    export default {
        name: 'unavailable-buttons',

        components: { BookingAlerts },

        props: {
            isComplete: {
                type: [Boolean, String],
                default() {
                    return false;
                },
            },

            spaceId: {
                type: [String, Number],
                default() {
                    return null;
                },
            },
        },

        data() {
            return {
                states: {
                    errors: [],
                },
            };
        },

        computed: {
            editRoute() {
                return `/list-your-space/${ this.spaceId }/progress/`;
            },
        },

        methods: {
            publishSpace() {
                return ListingRepository.update(this.spaceId, {
                    listing_completed_at: moment().format('YYYY-MM-DD'),
                }).then(() => {
                    window.location = this.$laroute.route('account.landlord.spaces.enable', { id: this.spaceId });
                }).catch((error) => {
                    this.states.errors = normaliseErrors(error);
                });
            },
        },
    };
</script>
